export default {
    Form: {
        Title: 'Abup Account Registration Center',
        SignIn: 'Sign In',
        Verification: 'Verification',
        Active: 'Active',
        Email: 'Email',
        EmailOrPhone: 'Email / Phone Number',
        Captcha: 'Captcha',

        China: "China",
        NonChina: "Non-China",
        GetSmsCaptcha: 'Obtain verification code', //获取短信验证码
        Reacquire: 'Reacquire', //重新获取
        SubmitSuccess: 'Submit Success', //提交成功

        ActiveAccount: 'Activate Account', //账号激活
        RetrievePassword: 'Retrieve The Password', //密码找回
        ResetPassword: 'Reset The Password', //重置密码
        ResetSuccessTips: 'The new password has been set successfully. Please remember your new password', //新密码设置成功，请牢记您的新密码
        SmsBack: 'Retrieve by email phone verification code', //手机验证码找回
        EmailBack: 'Retrieve by email', //邮箱找回
        VerifyEmail: 'The verification email has been sent successfully', //验证邮件已经发送成功
        VerifyTipsContentNote: 'If you have not received the verification email, we suggest you go to the spam box or click ', //若未收到验证邮件，建议您到邮件垃圾箱找找看，或点此

        Verify: 'Verification', //验证 verification
        Reset: 'Reset', //重置
        Complete: 'Complete', //完成
        Second: 'sec', //秒
    },
    Button: {
        SignIn: 'Sign In',
        Next: 'Next Step',
        Previous: 'Previous Step',
        ToLogin: 'To Log In',
        GotIt: 'Got It',
        Retry: 'Retry',
    },
    Placeholder: {
        EnterEmail: 'Enter email',
        EnterNewPassword: 'Enter new password', // 请输入新密码
        EnterConfirmPassword: 'Confirm password', // 确认密码
        EnterPassword: 'Enter password', // 输入密码
        EnterCaptcha: 'Enter verification code', //密码找回-输入验证码
        EnterCompanyName: '*Company Name(CN)', // 公司名称
        EnterCompanyNameEN: '*Company Name(EN) or Abbreviation', // 公司英文名
        DepartmentName: '*Department Name', //所属部门名称
        PositionName: '*Position Name', //职位
        Uname: '*Name', //姓名
        RefereeName: 'Recommend to fill in our business name', //推荐您使用的我司商务姓名
        EnterNote: 'Note', // 备注
        Country: '*Please select a country',  //请选择国家
        Region: '*Please select a region', //请选择您所在区域
        YourPhoneNumber: '*Phone Number', // 联系人手机号
        EnterImgCaptcha: '*Enter the graphic verification code', // 输入图形验证码
        EnterSmsCaptcha: '*Enter SMS verification code', // 输入短信验证码
        EnterConfirmNewPassword: 'Enter new password again', //确认新密码
        EnterPhoneNumber: 'Please enter phone number', //请输入手机号
        PleaseEnterSmsCaptcha: 'Please enter the SMS verification code' //请输入短信验证码
    },
    Validate: {
        Email: {
            // 邮箱/正确邮箱格式/邮箱被占用
            IsNull: 'Please enter email',
            IsCorrect: 'Please enter correct email address',
            IsRegistered: 'The mailbox has been registered, please log in directly',
            IsExists: 'The mailbox has been registered, please contact the administrator to confirm',
            IsUnregistered: 'Your email is unregistered',
        },
        Password: {
            // 注册登录 => 密码
            IsNull: 'please enter password',
            IsCorrect: 'The password length is between 6-20, supports numbers, letters, punctuation, contains no spaces, and contains at least two of them',
        },
        NewPassword: {
            // 修改密码 => 新密码 / 密码格式
            IsNull: 'please enter new password',
            IsCorrect: 'The password length is between 6-20, supports numbers, letters, punctuation, contains no spaces, and contains at least two of them',
        },
        ConfirmPassword: {
            // 确认密码
            IsNull: 'please enter password again',
            NotSame: 'Two password entries are inconsistent',
        },
        CompanyNameZh: {
            // 公司中文名
            IsNull: 'please enter company name in Chinese',
        },
        CompanyNameEn: {
            // 公司英文名
            IsNull: 'please enter company name in English',
            IsCorrect: 'Only English letters, numbers, commas, dots, underscores, horizontal lines, spaces are supported',
        },
        Region: {
            // 所在区域
            IsNull: 'Please select your region',
            CountryIsNull: 'Please select a country',
        },
        Phone: {
            // 联系人手机号
            IsNull: 'Please enter phone number',
            PhoneNumber: 'Please enter an 11-digit and valid mobile phone number',
            IsRegistered: 'The phone number has been registered, please log in directly',
            IsExists: 'The phone number has been registered, please contact the administrator to confirm',
        },
        Remark: {
            // 备注
            IsNull: 'Please enter notes',
        },
        Product: {
            // 项目
            NotSelect: 'Please select a project',
        },
        UserAssociated: {
            // 关联用户
            NotSelect: 'Please select an associated user',
        },
        DepartmentName: {
            // 部门
            IsNull: 'Please enter your department',
        },
        PositionName: {
            // 职位
            IsNull: 'Please enter your position',
        },
        Name: {
            // 名称
            IsNull: 'Please enter your name',
        },
        RefereeName: {
            // 推荐人
            IsNull: 'Please enter the name of Reference',
        },
        Captcha: {
            // 图形验证码
            IsNull: 'Please enter the graphic verification code',
            IsError: 'Please enter the correct graphic verification code',
        },
        SmsCaptcha: {
            // 短信验证码
            IsNull: 'Please enter the SMS verification code',
            IsError: 'SMS verification code is incorrect',
            minLength: 'The verification code must not be less than 6 characters',
        },
        StringLength: {
            // 字符串长度
            Length200: 'Length is less than 200 characters',
            Length100: 'Length is less than 100 characters',
            Length20: 'Length is less than 20 characters',
        },
    },
    Message: {
        SendSuccess: 'The SMS verification code has been sent to the mobile phone, please check',
        NotPhone: 'Please enter your phone number first',  //请先输入手机号
        DefaultSuccess: 'Operate success', // 操作成功
        DefaultError: 'Operate failed', // 操作失败
        VerifiySuccess: 'Verified successfully', // 验证成功
        ActivationFails: 'Activation Fails', //激活失败

        MsgCode201: 'Add success', //添加成功
        MsgCode202: 'Modification success', // 修改成功
        MsgCode203: 'Delete success', // 删除成功
        MsgCode204: 'Add fail', //添加失败
        MsgCode205: 'Modification fail', //修改失败
        MsgCode206: 'Delete fail', //删除失败

        MsgCode1: 'User account frozen', //用户账号已冻结
        MsgCode2: 'User account to be audited', // 用户账号待审核
        MsgCode3: 'User account to be activated', // 用户账号待激活
        MsgCode4: 'User account audit failed', //用户账号审核不通过
        MsgCode5: 'User account password error', //用户账号密码错误
        MsgCode6: 'User account does not exist', //用户账号不存在
        MsgCode7: 'Freeze fail', //冻结失败
        MsgCode8: 'Freeze success', //冻结成功
        MsgCode9: 'Unfreeze fail', //解冻失败
        MsgCode10: 'Unfreeze success', //解冻成功
        MsgCode11: 'Role assignment fail', //角色分配失败
        MsgCode12: 'Role assignment success', //角色分配成功
        MsgCode13: 'Registration fail', //注册失败
        MsgCode14: 'Successful registration', //注册成功
        MsgCode15: 'Mailbox occupied', //邮箱已被占用
        MsgCode16: 'Mailbox not registered', //邮箱未注册
        MsgCode17: 'The mailbox inactivated', //邮箱未激活
        MsgCode18: 'Link has failed', //链接已失效
        MsgCode19: 'Fail to retrieve the password', //找回密码失败
        MsgCode20: 'Success to retrieve the password', //找回密码成功
        MsgCode21: 'Fail to add role', //添加角色失败
        MsgCode22: 'Fail to add due to the same role name!', //添加失败,角色名称不能相同！
        MsgCode23: 'Fail to assign permissions', //分配权限失败
        MsgCode24: 'Successful allocation of permissions', //分配权限成功
        MsgCode25: 'Audit failure', //审核失败
        MsgCode26: 'Failed to send activate mail', //激活邮件发送失败
        MsgCode27: 'Success to deliver activate mail', //激活邮件发送成功
        MsgCode28: 'Picture verification code is incorrect', //图片验证码不正确
        MsgCode29: 'Fail to send retrieve password activation mail', //找回密码激活邮件发送失败
        MsgCode30: 'Success to send password recovery activation mail', //找回密码激活邮件发送成功
        MsgCode31: 'Fail to send mail', //邮件发送失败
        MsgCode32: 'Audit fail, mail fail to send', //审核不通过，邮件发送未成功
        MsgCode33: 'Audit fail, mail success to send', //审核不通过，邮件发送成功
        MsgCode34: 'Fail to update difference validity period', //差分有效期更新失败
        MsgCode35: 'Fail to delete project and user permissions', //删除项目和用户权限失败
        MsgCode36: 'Delete project and user permissions successfully', //删除项目和用户权限成功
        MsgCode37: 'Delete fail and at least one project association is kept', //删除失败，至少保留一个项目关联
        MsgCode38: 'Fail to modify project and user permissions', //修改项目和用户权限失败
        MsgCode39: 'Success to modify project and user permissions', //修改项目和用户权限成功
        MsgCode40: 'Fail to add project and user permissions', //添加项目和用户权限失败
        MsgCode41: 'Success to add project and user permissions', //添加项目和用户权限成功
        MsgCode42: 'Fail to reset sub-account password. The reset password cannot be same as original password', //子账户重置密码失败，重置密码不能与原密码一样
        MsgCode43: 'The mailbox is occupied', //该邮箱已占用
        MsgCode44: 'Sub-account addition failed, not more than 100', //子账户添加失败,不能超过100个
        MsgCode45: 'The sub-account has been added successfully, and the delivery of the active message failed', //子账户添加成功，激活邮件发送失败
        MsgCode46: 'Fail to add sub-account', //子账户添加失败
        MsgCode47: 'Sub-account resend activation message fail', //子账户重新发送激活邮件失败
        MsgCode48: 'The difference validity period has been updated successfully', //差分有效期更新成功
        MsgCode49: 'Activation fail, please register again', //激活失败，请重新注册
        MsgCode50: 'Activation success', //激活成功
        MsgCode51: 'Password change fail due to the old password and new one are same', //修改密码失败，新老密码一致
        MsgCode52: 'Password change fail due to original password error', //修改密码失败，原密码错误
        MsgCode53: 'Account activation fail due to account does not exist', //账号激活失败，账户不存在
        MsgCode54: 'Activation emails cannot be sent to invalid email addresses.', //非正常状态用户不能发送激活邮件 - 修改为：错误的邮箱不能发送激活邮件
        MsgCode550: 'The number of verification codes obtained today has reached the upper limit, please try again tomorrow', //今日获取验证码次数已达上限，请明日重试
        MsgCode551: 'The SMS verification code is wrong (or has expired), please re-enter (or get it again)', //短信验证码错误（或已失效），请重新输入（或重新获取）
        MsgCode552: 'SMS verification code has timed out', //短信验证码已超时
        MsgCode553: 'SMS failed to send', //短信发送失败
        MsgCode547: 'Phone number is already occupied', //手机号已被占用
        MsgCode548: 'Please enter an 11-digit and valid mobile phone number', //请输入11位且有效的手机号码
        MsgCode559: 'There is no user bound to the mobile phone number', //不存在绑定该手机号的用户
        MsgCode100001: 'System exception, please try again later', //系统异常，请稍后重试
        MsgCode100002: 'System exception, please try again later', //系统异常，请稍后重试
        MsgCode535: 'User account is frozen', //用户账号已冻结
    },

    /* 提交成功页面提示信息 */
    SubmitSuccessPageInfo: {
        title: 'Submitted successfully', // dialog 标题
        main:
            'During the account audit, the staff of our company will review your registration information within 1-2 working days. At that time, your email will receive the activation email or the rejected email', // 主要内容
        tips: {
            // 提示
            title: 'warm prompt:',
            data: [
                { msg: 'Due to different mailbox server security Settings, the activated mail may be misjudged as spam by the server.' },
                {
                    msg: 'If you do not receive the email after 2 working days, please try the following solution:',
                    children: ['<div><span class="eyes-on">Reset</span>registration information</div>', '<div>Email: care@boltt.com | Phone:022-69089822</div>'],
                },
                { msg: 'Working hours: Monday to Friday, 9:30am-18:00pm.' },
            ],
        },
    }
}
